import { createNamespacedHelpers } from 'vuex';
import BaseStore from '@/store';
import actions from './newDeviation.actions.js';
import getters from './newDeviation.getters.js';
import mutations from './newDeviation.mutations.js';
import state from './newDeviation.state.js';

BaseStore.registerModule('newDeviation', {
	namespaced: true,
	state: state(),
	mutations,
	actions,
	getters
});
export default BaseStore;

let { mapState, mapGetters, mapMutations, mapActions } = createNamespacedHelpers('newDeviation');

export {
	mapState,
	mapGetters,
	mapMutations,
	mapActions
};
